import type { Color } from '@ark-ui/react/color-picker'

export const isColorWhite =
	(parseColor: (color: string) => Color) => (colorString: string) => {
		try {
			const parsedColor = parseColor(colorString)
			return parsedColor.toString('hexa').toUpperCase() === '#FFFFFFFF'
		} catch {
			return false
		}
	}

export const safeParseColor =
	(parseColor: (color: string) => Color) => (colorString?: string) => {
		if (!colorString) {
			return null
		}

		try {
			return parseColor(colorString)
		} catch {
			return null
		}
	}
